import { AbstractDTO } from './abstract';

export class AiAssistantRequestDTO extends AbstractDTO {
    content: string;
    data: string;
    action_var: string;
   // file_id: string;
    vs_is: string;
    thread_id: string;
    content_type: string;
    obj_type: string;
    obj_id: string;
    data_type: string;
    vs_var: string;
    asst_var: string;

    constructor(attributes?: Object) {
        attributes = attributes ? attributes : {};
        super(attributes);

        this.content = attributes['content'] || '';
        this.data = attributes['data'] || '';
        this.action_var = attributes['actionVar'] || '';
       // this.file_id = attributes['fileId'] || '';
        this.vs_is = attributes['vsIs'] || '';
        this.thread_id = attributes['threadId'] || '';
        this.content_type = attributes['contentType'] || '';
        this.obj_type = attributes['objType'] || '';
        this.obj_id = attributes['objId'] || '';
        this.data_type = attributes['dataType'] || '';
        this.vs_var = attributes['vsVar'] || '';
        this.asst_var = attributes['asstVar'] || '';
    }
}
